/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UrlResponseDto } from '../../models/url-response-dto';

export interface MediaControllerGetUploadUrl$Params {
}

export function mediaControllerGetUploadUrl(http: HttpClient, rootUrl: string, params?: MediaControllerGetUploadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UrlResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerGetUploadUrl.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UrlResponseDto>>;
    })
  );
}

mediaControllerGetUploadUrl.PATH = '/thalea-documents/upload-url';
